<template>
    <div class="main-app mt-12" style="background-color:#e7e7e7 !important;">
        <div>
            <v-container v-if="properties_detail" class="container-600">
                <!--            <h2 class="blue-grey&#45;&#45;text mt-12">รายละเอียดห้อง</h2>-->
                <h3 class="text-lpn pt-5">{{ properties_detail.project_name_th }}</h3>
                <v-divider/>
                <div id="properties_w8_payment" class="mt-5 mb-12 pb-10">
                    <!--                <h3>รายการจองทั้งหมด</h3>-->
                    <div class='row'>
                        <div class="col-12">
                            <v-card class="mx-auto">
                                <v-container class="pa-0">
                                    <v-row class="ma-0 py-0">
                                        <!-- slide นะจ๊ะ -->
                                        <v-col class="pa-0 col-12">

                                            <div style="position: relative;">
                                                <div class="d-flex">
                                                    <div class="col-5" :style="'border-left: 10px solid'+getProjectColor(properties_detail.project_shortname)+';background:#f2f2f2;'">
                                                        <div class="d-flex flex-column  justify-space-between text-detail-color" style="height: 100%;">
                                                            <div class="font-weight-bold" style="font-size: 1.25em;">{{properties_detail.property_unit_code}}</div>
                                                            <div style="line-height: 1em">
                                                                <span v-if="parseFloat(properties_detail.price_total_amount)>0&&(properties_detail.hasOwnProperty('property_is_open_for_sale')&&properties_detail.property_is_open_for_sale=='Y')" class="mr-3" style="font-size: 1.2em;text-decoration-line: line-through;">{{properties_detail.property_contract_max_price | formatNumber}}</span>
                                                                <div class="mt-2" style="font-size: 0.85em;">{{properties_detail.unit_type_name_th}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-7 pa-0" style="background:#f2f2f2;">
                                                        <div v-if="slides&&slides.length>0" class="text-center">
                                                            <swiper class="swiper" ref="roomSampleSlide" :options="swiperOption" style="max-width:600px;"
                                                                    @click-slide="handleClickSlide"
                                                            >

                                                                <swiper-slide
                                                                        v-for="(slide, i) in slides"
                                                                        :key="i"
                                                                >
                                                                    <img :src="slide.pj_image_link" style="width: 100%;">
                                                                </swiper-slide>

                                                                <div v-if="(slides&&slides.length>1 ? true:false)"  class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                                                                <div v-if="(slides&&slides.length>1 ? true:false)"  class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                                                                <div v-if="(slides&&slides.length>1 ? true:false)"  class="swiper-button-next swiper-button-white" slot="button-next"></div>
                                                            </swiper>
                                                        </div>
                                                        <div v-else class="text-center">
                                                            <img @click="showFullSlide()" :src="properties_detail.prop_image_link" style="width: 100%;max-width: 900px;">
                                                        </div>

                                                    </div>
                                                </div>
                                                <div v-if="!properties_detail.available_status" class="sold text-center" style="position: absolute;top:50%;width: 100%;opacity: 0.65;z-index: 2">
                                                    <div class="pa-2 bg-lpn white--text" style="margin: -20px auto;width: 60%;">จองแล้ว SOLD</div>
                                                </div>
                                            </div>

                                        </v-col>

                                        <v-col class="text-left pl-6 pr-2 py-2 col-12">
                                            <h4 class="mt-2 font-weight-regular text-detail-color">ข้อมูลห้องชุด</h4>
                                            <v-divider class="mb-2"/>
                                            <div class="row mx-1" style="font-size: 0.85em">
                                                <div class="col-5 col-sm-3 col-md-3 col-lg-3 px-1 py-1">โครงการ</div>
                                                <div class="col-7 col-sm-9 col-md-9 col-lg-9 px-1 py-1 text-detail-color">{{properties_detail.project_name_th }}</div>

                                                <div class="col-5 col-sm-3 col-md-3 col-lg-3 px-1 py-1">ห้องชุด</div>
                                                <div class="col-7 col-sm-9 col-md-9 col-lg-9 px-1 py-1 text-detail-color">{{properties_detail.property_unit_code }}</div>

                                                <div class="col-5 col-sm-3 col-md-3 col-lg-3 px-1 py-1">ขนาดห้อง</div>
                                                <div class="col-7 col-sm-9 col-md-9 col-lg-9 px-1 py-1 text-detail-color">{{properties_detail.property_area | formatNumber2Digit}} {{ properties_detail.property_type_code=='CONDO' ? 'ตร.ม.':'ตร.ว.' }}</div>

                                                <div class="col-5 col-sm-3 col-md-3 col-lg-3 px-1 py-1">รูปแบบ</div>
                                                <div class="col-7 col-sm-9 col-md-9 col-lg-9 px-1 py-1 text-detail-color">{{properties_detail.unit_type_name_th}}</div>

                                                <div class="col-5 col-sm-3 col-md-3 col-lg-3 px-1 py-1">ชั้น</div>
                                                <div class="col-7 col-sm-9 col-md-9 col-lg-9 px-1 py-1 text-detail-color">{{properties_detail.property_floor }}</div>

                                                <div class="col-5 col-sm-3 col-md-3 col-lg-3 px-1 py-1">ทิศ</div>
                                                <div class="col-7 col-sm-9 col-md-9 col-lg-9 px-1 py-1 text-detail-color">ทิศ{{properties_detail.direction_name_th }}</div>

                                            </div>
                                        </v-col>

                                        <v-col v-if="parseFloat(properties_detail.price_total_amount)>0&&(properties_detail.hasOwnProperty('property_is_open_for_sale')&&properties_detail.property_is_open_for_sale=='Y')" class="text-left pl-6 pr-2 py-2 col-12">
                                            <h4 class="mt-2 font-weight-regular text-detail-color">ข้อมูลราคา</h4>
                                            <v-divider class="mb-2"/>
                                            <div class="row mx-1" style="font-size: 0.85em">
                                                <div class="col-5 col-sm-3 col-md-3 col-lg-3 px-1 py-0">ราคา</div>
                                                <div class="col-7 col-sm-9 col-md-9 col-lg-9 px-1 py-0 text-detail-color"><span style="text-decoration-line: line-through;">{{properties_detail.property_contract_max_price | formatNumber}}</span> บาท</div>

                                                <div class="col-5 col-sm-3 col-md-3 col-lg-3 px-1 py-0">ส่วนลด</div>
                                                <div class="col-7 col-sm-9 col-md-9 col-lg-9 px-1 py-0 red--text">{{ (parseFloat(properties_detail.property_contract_max_price)-parseFloat(properties_detail.price_total_amount)) | formatNumber}} บาท</div>

<!--                                                <div class="col-5 col-sm-3 col-md-3 col-lg-3 px-1 py-0 text-lpn font-weight-bold">ส่วนลดพนักงาน</div>-->
<!--                                                <div class="col-7 col-sm-9 col-md-9 col-lg-9 px-1 py-0 text-detail-color font-weight-bold red&#45;&#45;text text&#45;&#45;accent-4">{{ (parseFloat(properties_detail.pp_prop_middle_amount)-parseFloat(properties_detail.price_total_amount)) | formatNumber}} บาท</div>-->

                                                <div class="col-5 col-sm-3 col-md-3 col-lg-3 px-1 py-0">ราคาสุทธิ</div>
                                                <div class="col-7 col-sm-9 col-md-9 col-lg-9 px-1 py-0 text-lpn font-weight-bold">{{parseFloat(properties_detail.price_total_amount)  | formatNumber}} บาท</div>

                                                <div class="col-5 col-sm-3 col-md-3 col-lg-3 px-1 py-0">เงินจอง</div>
                                                <div class="col-7 col-sm-9 col-md-9 col-lg-9 px-1 py-0 text-lpn">{{ properties_detail.pp_prop_deposit_amount | formatNumber}} บาท</div>
                                            </div>
                                        </v-col>


                                        <v-col v-if="furniture&&furniture.length>0" class="text-left pl-6 pr-2 py-2 col-12">
                                            <h4 class="mt-2 font-weight-regular text-detail-color">ฟรีโปรโมชั่น</h4>
                                            <v-divider class="mb-2"/>
                                            <div class="row mx-1" style="font-size: 0.85em">
                                                <div v-for="(item,i) in furniture" class="col-12 px-1 py-1 text-detail-color">
                                                    <div class="row">
                                                        <div class="col-8 pr-1">
                                                            <span class="mr-2">{{ i+1 }}.</span>
                                                            {{ item.FUR_NAME_TH }}
                                                            <span v-if="item.pp_free_qty&&item.UT_NAME_TH" class="ml-2 grey--text">
                                                                <span class="mr-2">{{ item.pp_free_qty }}</span>
                                                                <span  v-if="item.UT_NAME_TH" class="">{{ item.UT_NAME_TH }}</span>
                                                            </span>
                                                        </div>

                                                        <div class="col-4 text-right px-1" v-if="item.pp_free_total_price&&item.pp_free_total_price>0">{{ item.pp_free_total_price | formatNumber }} บาท</div>
                                                    </div>
                                                </div>

<!--                                                <div v-if="furnitureSum > 0" class="col-12 text-lpn text-right font-weight-bold">รวมมูลค่า {{ furnitureSum | formatNumber }} บาท</div>-->

                                            </div>
                                        </v-col>

                                        <v-col v-if="furniture_plan&&furniture_plan.length>0" class="text-left pl-6 pr-2 py-2 col-12">
                                            <h4 class="mt-2  font-weight-regular text-detail-color">ผังห้อง</h4>
                                            <v-divider class="mb-2"/>
                                            <div class="row mx-1" style="font-size: 0.85em">
                                                <div  class="col-12 px-1 py-1">
                                                    <v-carousel
                                                            cycle
                                                            continuous
                                                            height="100%"
                                                            hide-delimiter-background
                                                            hide-delimiters
                                                            :show-arrows="false"
                                                    >
                                                        <v-carousel-item
                                                                v-for="(fp, i) in furniture_plan"
                                                                :key="i"
                                                                :src="fp.pj_image_link"
                                                                @click="showFullScreen(fp.pj_image_link)"
                                                        >
                                                        </v-carousel-item>
                                                    </v-carousel>
                                                    <span style="color: white;">&nbsp;.</span><!-- add . for stupid a bug -->
                                                </div>
                                            </div>
                                        </v-col>

                                        <v-col v-if="floor_plan&&floor_plan.length>0" class="text-left pl-6 pr-2 py-2 col-12">
                                            <h4 class="mt-2 font-weight-regular text-detail-color">ผังพื้น</h4>
                                            <v-divider class="mb-2"/>
                                            <div class="row mx-1" style="font-size: 0.85em">
                                                <div  class="col-12 px-1 py-1">
                                                    <v-carousel
                                                            cycle
                                                            continuous
                                                            height="100%"
                                                            hide-delimiter-background
                                                            hide-delimiters
                                                            :show-arrows="false"
                                                    >
                                                        <v-carousel-item
                                                                v-for="(fp, i) in floor_plan"
                                                                :key="i"
                                                                :src="fp.pj_image_link"
                                                                @click="showFullScreen(fp.pj_image_link)"
                                                        >
                                                        </v-carousel-item>
                                                    </v-carousel>
                                                </div>
                                            </div>
                                        </v-col>

                                    </v-row>
                                </v-container>
                                <v-card-actions class="d-flex flex-row justify-space-between pa-0" >
                                    <div
                                            v-if="campaign_id&&!isEvent('PreSale')&&((properties_detail.hasOwnProperty('project_is_open_for_sale')&&properties_detail.project_is_open_for_sale=='Y')&&(properties_detail.hasOwnProperty('property_is_open_for_sale')&&properties_detail.property_is_open_for_sale=='Y'))"
                                            class="col pa-0"
                                    >
                                        <v-btn
                                                color="#e0e0e0"
                                                block
                                                tile
                                                :disabled="(properties_detail.available_status ? false:true)"
                                                class="text-lpn"
                                                style="height: 28px;"
                                                @click="makeQuatation(properties_detail)"
                                        >
                                            <v-icon left small>
                                                mdi-file-document-outline
                                            </v-icon>
                                            ใบเสนอราคา <span v-if="properties_detail.cnt_quatation" class="red--text">({{ properties_detail.cnt_quatation }})</span>
                                        </v-btn>
                                    </div>
                                    <div v-if="isEvent('PreSale')" class="col pa-0">
                                        <v-btn
                                                :color="properties_detail.is_favorite&&properties_detail.is_favorite=='Y' ?  '#d48b07':'#e0e0e0'"
                                                block
                                                tile
                                                :disabled="(properties_detail.available_status ? false:true)"
                                                :class="properties_detail.is_favorite&&properties_detail.is_favorite=='Y' ?  'white--text':'text-lpn'"
                                                style="height: 28px;"
                                                @click="addFavorite(properties_detail)"
                                        >
                                            <v-icon left :color="properties_detail.is_favorite&&properties_detail.is_favorite=='Y' ?  'orange accent-1':'grey'">
                                                mdi-star
                                            </v-icon>
                                            {{ properties_detail.is_favorite&&properties_detail.is_favorite=='Y' ?  'รายการที่สนใจ':'สนใจ'  }}
                                        </v-btn>
                                    </div>

                                    <div
                                            class="col pa-0"
                                            v-if="((properties_detail.hasOwnProperty('project_is_open_for_sale')&&properties_detail.project_is_open_for_sale=='Y')&&(properties_detail.hasOwnProperty('property_is_open_for_sale')&&properties_detail.property_is_open_for_sale=='Y'))&&!isEvent('StaffGetMember')"
                                    >
                                        <v-btn
                                                v-if="!isEvent('PreSale')&&!isEvent('StaffGetMember')"
                                                :color="(cartItemFind(properties_detail) ? getProjectColor(properties_detail.project_shortname):'#16448f')"
                                                block
                                                tile
                                                :disabled="(properties_detail.available_status ? false:true)"
                                                class="white--text save_cart2 justify-space-between"
                                                id="save_cart2"
                                        >

                                                <div>
                                                    เงินจอง {{ properties_detail.pp_prop_deposit_amount | formatNumber}} บาท
                                                </div>
                                                <div @click="bookNow(properties_detail,campaign_id)" class="pa-2 px-3 text-lpn" style="border-radius: 5px;background-color: #ffffff;margin-right: -10px;font-weight: bold;font-size: 1.15em;">
                                                    <v-icon left>
                                                        mdi-cart-outline
                                                    </v-icon>
                                                    จองห้องนี้
                                                </div>

                                        </v-btn>
                                        <v-btn
                                                v-else
                                                :color="(cartItemFind(properties_detail) ? getProjectColor(properties_detail.project_shortname):'#16448f')"
                                                block
                                                tile
                                                :disabled="(properties_detail.available_status ? false:true)"
                                                class="white--text"
                                                style="height: 28px;"
                                                @click="addCartItem(properties_detail,campaign_id)"
                                        >
                                            <v-icon left small>
                                                {{(cartItemFind(properties_detail) ? 'mdi-check':'mdi-cart-outline')}}
                                            </v-icon>
                                            {{(cartItemFind(properties_detail) ? 'เลือกแล้ว':'จองห้องนี้')}}

                                        </v-btn>
                                    </div>
                                </v-card-actions>
                            </v-card>
                        </div>
                    </div>
                </div>

            </v-container>
        </div>

        <!-- only SGM -->
        <quatation-form  v-if="campaign_id&&isEvent('StaffGetMember')" v-bind:quatation_properties="quatation_properties" v-bind:quatation_dialog="quatation_dialog"  @toggleQuatationDialog="toggleQuatationDialog" :campaign_id="campaign_id"/>

        <!-- แสดงห้องที่ user เลือก -->
        <selected-properties-tool-bar  ref="selected_properties" v-bind="{cart_item:current_cart_item}"></selected-properties-tool-bar>

        <v-overlay v-if="properties_detail" :value="overlay" :opacity="0.8">
            <div @click="overlay=false" class="close_fullcsreen_slide" style="position: absolute;right:10px;z-index: 9999;top:-30px;">
                Close<v-icon right>mdi-close</v-icon>
            </div>
            <div v-if="slides&&slides.length>0" class="text-center">
                <swiper class="swiper" ref="roomSampleSlideFullScreen" :options="swiperOption_fullscreen" style="max-width:100vw;max-height: 100vh;">

                    <swiper-slide
                            v-for="(slide, i) in slides"
                            :key="i"
                    >
                        <img :src="slide.pj_image_link" style="max-width: 100%;max-height: 100vh;">
                    </swiper-slide>

                    <div v-if="(slides&&slides.length>1 ? true:false)"  class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                    <div v-if="(slides&&slides.length>1 ? true:false)"  class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                    <div v-if="(slides&&slides.length>1 ? true:false)"  class="swiper-button-next swiper-button-white" slot="button-next"></div>
                </swiper>
            </div>
            <div v-else class="text-center">
                <img :src="properties_detail.prop_image_link" style="max-width: 100%;max-height: 90vh;">
            </div>
        </v-overlay>

        <v-overlay v-if="images_path" :value="overlay2" :opacity="0.8">
            <div @click="overlay2=false" class="close_fullcsreen_slide" style="position: absolute;right:10px;z-index: 9999;top:-30px;">
                Close<v-icon right>mdi-close</v-icon>
            </div>
            <div class="text-center">
                <img :src="images_path" style="max-width: 100%;max-height: 90vh;">
            </div>
        </v-overlay>

    </div>
</template>

<script>
    import SelectedPropertiesToolBar from '@/components/saleOnline/SelectedPropertiesToolBar'
    import ProjectHeader from "@/components/saleOnline/ProjectHeader";
    import QuatationForm from '@/components/saleOnline/QuatationForm'


    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'

    export default {
        name: "PropertiesDetail",
        components:{
            selectedPropertiesToolBar:SelectedPropertiesToolBar,
            projectHeader:ProjectHeader,
            quatationForm:QuatationForm,
            Swiper,
            SwiperSlide
        },
        data(){
            return{
                current_loading_state:{
                    show:false,
                    message:'กำลังโหลดข้อมูล....กรุณารอสักครู่.',
                    progressColor:'blue'
                },
                project_images: null,
                overlay: false,
                overlay2: false,
                images_path: '',
                slides: [],
                properties_detail:null,
                project_id:null,
                project_detail: null,
                route_data: null,
                furniture: [],
                furniture_plan: null,
                floor_plan: null,
                quatation_properties:{},
                quatation_dialog:false,
                campaign_id:null,
                campaign_data: null,
                properties_images: [],
                swiperOption: {
                    // autoHeight: true, //enable auto height
                    spaceBetween: 20,
                    loop: true,
                    // slidesPerView: 'auto',
                    speed: 500,
                    // effect: 'fade',
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                swiperOption_fullscreen: {
                    spaceBetween: 20,
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                is_search:false
            }
        },
        async mounted(){
            window.scrollTo(0,0)
            // check auth login with LINE is valid
            if (!this.getSavedLocalItem(this.local_customer_key)) {
                return this.logout()
            }

            //change this to get project details by project_id params from API
            const local_project_detail = this.getSavedLocalItem(this.local_project_key)
            if(local_project_detail&&local_project_detail.hasOwnProperty('project_id')&&local_project_detail.project_id==this.project_id){
                this.project_detail = local_project_detail
            }else {
                this.project_detail = await this.getProjectDetails(this.project_id)
                this.saveSelectedProject(this.project_detail)
            }

            this.properties_detail = this.getSavedLocalItem(this.local_property_key)
            if(this.properties_detail&&this.properties_detail.hasOwnProperty('favorite_create_by')){
                this.properties_detail.is_favorite = 'Y'
            }


            this.route_data = this.genRouteData

            this.furniture = await this.getFurniture()

            if(this.$route.query.hasOwnProperty('search')&&this.$route.query.search=='1'){
                this.is_search = true
                this.setTopNav(
                    true,
                    'รายละเอียดห้อง',
                )
            }else{
                this.setTopNav(
                    true,
                    'รายละเอียดห้อง',
                    this.route_data.back_route.name,
                    this.route_data.back_route.params
                )
            }

            this.project_images = await this.getProjectImages()
            this.properties_images = await this.getPropertiesImages()

            // this.slides = this.getPropertiesImageByRoomType(this.properties_detail.pj_room_type_id,['sample','furnitureplan'],this.properties_detail.project_code)
            this.slides = this.properties_images&&this.properties_images.length>0
                ? this.properties_images
                :this.getPropertiesImageByRoomType(this.properties_detail.pj_room_type_id,['sample'],this.properties_detail.project_code)
            // console.log(this.slides)

            this.furniture_plan = this.getPropertiesImageByRoomType(this.properties_detail.pj_room_type_id,['furnitureplan'],this.properties_detail.project_code)
            // this.floor_plan = this.getPropertiesImageByRoomType(this.properties_detail.pj_room_type_id,['floorplan'],this.properties_detail.project_code)
            if(this.slides&&this.slides.length>0){
                // this.swiper.slideNext()
                // this.swiper.slideNext()
                // this.swiper.slideNext()
            }

            if(this.isEvent('PreSale')){
                await this.updatePropertyScore(this.properties_detail.property_id,1)
            }

            this.$nextTick(() => {
                if(!this.isEvent('PreSale')&&!this.isEvent('StaffGetMember')){
                    document.querySelector("div#selected_properties_in_cart").remove();
                    if(document.getElementById("save_cart2")) {
                        document.getElementById("save_cart2").style.display = 'inline-block';
                    }
                }

            })
            //
        },
        watch:{
            overlay(val) {
                if (val) {
                    document.addEventListener('mousedown', this.mousedownHandler)
                } else {
                    document.removeEventListener('mousedown', this.mousedownHandler)
                }
            },
            overlay2(val) {
                if (val) {
                    document.addEventListener('mousedown', this.mousedownHandler)
                } else {
                    document.removeEventListener('mousedown', this.mousedownHandler)
                }
            }
        },
        created() {
            //แสดงเลข version
            store.commit('changeShowVersionState', false)

            //แสดงเมนูด้านล่าง และกำหนดรายการเมนู
            this.setBottomNav(true,[],'sale_online')

            if(this.$route.query.hasOwnProperty('project_id')){
                this.project_id = this.$route.query.project_id
            }

            // this.setTopNav(false)

            if(this.$route.query.hasOwnProperty('camp')){
                if(this.$route.query.camp!='') {
                    this.campaign_id = this.$route.query.camp
                    this.campaign_data = this.getSavedLocalItem(this.local_camp_key)
                }
            }

            this.reCheckCartItem()

            //ซ่อน flash massage
            store.commit('changeFlashState',{show:false})
        },
        computed: {
            furnitureSum(){
                return  this.furniture.reduce(function(total, fur){
                    return total + (fur.pp_free_total_price ? parseFloat(fur.pp_free_total_price):0)
                }, 0);
            },
            genRouteData() {
                const data = {
                    back_route: {
                        name: 'saleOnline_propertiesList',
                        params: {project_id: (this.project_detail ? this.project_detail.project_id : 0)}
                    }
                }
                return data
            },
            swiper() {
                return this.$refs.roomSampleSlide.$swiper
            }
        },
        methods:{
            mousedownHandler(e) {
                if (e.target.classList.contains('v-overlay__scrim')){
                    this.overlay = false
                    this.overlay2 = false
                }
            },
            handleClickSlide(index, reallyIndex) {
                this.showFullSlide()
                // this.swiper.slideTo(reallyIndex, 2000, false)
                return true
            },
            async getFurniture(){

                const requestBody = {
                    pp_id: this.properties_detail.pp_id,
                    property_id: this.properties_detail.property_id,
                }

                let promiseChecking, result = null

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/PropertyFreebies', requestBody,true,'json'))


                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        result = promiseChecking.result.res.data.result
                    }
                }
                return result
            },
            async getPropertiesImages(){
                const requestBody = {
                    property_id:this.properties_detail.property_id
                }

                let promiseChecking, finalResult = [],finalResult2 = []

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/getPropertyImage',requestBody,true,'json'))

                if (!promiseChecking.error) {
                    if(promiseChecking.result.res.data.code=='000'){
                        finalResult = [...promiseChecking.result.res.data.result]

                        //เปลี่ยน key path รูปของ project image กับ property image ให้ตรงกัน
                        if(finalResult.length>0){
                            for (let i in finalResult) {
                                finalResult2.push({ pj_image_link: finalResult[i].prop_image_link})
                            }
                        }
                    }
                }

                return finalResult2
            },
            async getProjectImages(){
                const requestBody = {
                    project_id:this.properties_detail.project_id
                }

                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/getProjectImages',requestBody,true,'json'))

                if (!promiseChecking.error) {
                    if(promiseChecking.result.res.data.code=='000'){
                        finalResult = [...promiseChecking.result.res.data.result]
                    }
                }

                return finalResult
            },
            getPropertiesImageByRoomType(room_type,cat,project_code){

                let data = this.project_images ? this.project_images.filter(n =>
                    cat.indexOf(n.pj_image_category)>-1 &&
                    n.pj_room_type_id==room_type &&
                    n.project_code==project_code
                ):{}

                return data
            },
            scrollToDiv(elem_id){
                let container = this.$el.querySelector(elem_id);
                container.scrollIntoView()
            },
            toggleQuatationDialog(quatation_form){
                this.quatation_dialog =  quatation_form.show
            },
            makeQuatation(properties){
                // console.log(properties)
                this.quatation_properties =  properties
                this.quatation_dialog =  true
                return true
            },
            showFullSlide(){
                // console.log("full slide")
                this.overlay = true
            },
            showFullScreen(image){
                // console.log(image)
                this.images_path = image
                this.overlay2 = true
            },
            async addFavorite(properties){

                //แสดง loading
                this.current_loading_state.show = true
                store.commit('changeLoadingState', this.current_loading_state)

                let fav = properties&&properties.is_favorite== 'Y' ? 'N':'Y'

                let result = await this.saveFavorite(properties.property_id,fav)

                if(result) {
                    properties.is_favorite = fav
                    properties.reloadedEvent = 1

                    //update favorite total notification in main menu
                    let total_favorite = await this.getFavoriteSummary()
                    if (total_favorite && total_favorite.hasOwnProperty('count_favorite') && parseInt(total_favorite.count_favorite) > 0) {
                        this.updateNotification('favorite', total_favorite.count_favorite)
                    } else {
                        this.updateNotification('favorite', 0)
                    }
                    this.setBottomNav(true, [], 'sale_online')
                }

                //ซ่อน loading
                this.current_loading_state.show = false
                store.commit('changeLoadingState', this.current_loading_state)
            },
        }

    }
</script>

<style scoped>
    .remove_item{
        position: absolute;
        right: -8px;
        top:-8px;
        cursor: pointer;
    }
    .remove_item:hover{
        color:red;
    }

    .text-detail-color{
        color:#595a5c;
    }

    .swiper-button-next:after, .swiper-button-prev:after{
        font-size: 1.25em !important;
    }

    .save_cart2{
        display: none;
        position: fixed;
        bottom: 56px;
        height: 50px !important;
        left:0;
        background-color: #e9e9e9;
        padding: 0 10px 10px 10px;
        z-index: 2;
        box-shadow: 0 -8px 10px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12)!important;

    }
    .save_cart2:before {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        height: 50px;
        top: -50px;
        left: 0;
        background-image: -webkit-gradient(linear, left top, left bottom, from(#e7e7e7), to(#e7e7e7));
        background-image: linear-gradient(rgba(233, 233, 233, 0), #e7e7e7);
    }

</style>
